import {useEffect, useState} from "react";
import {Link, useLocation} from "react-router-dom";
import type {I18nKey} from "@corporatesclub/shared";
import {useI18n} from "./I18nProvider";
import {CategoryBrowseOverlay, openCategoryBrowse} from "./CategoryBrowseOverlay";

type NavItem = {id: string; labelKey: I18nKey; to: string; promo?: boolean};

import {paths} from "@/lib/paths";

const LINKS: NavItem[] = [
  {id: "brands", labelKey: "Brands", to: paths.brands},
  {id: "free-shipping", labelKey: "Free shipping", to: paths.freeShipping},
  {id: "discounts", labelKey: "Discounts", to: paths.promotions, promo: true},
  {id: "best-sellers", labelKey: "Best Sellers", to: paths.bestSellers},
  {id: "new", labelKey: "New", to: paths.new}
];

export function HeaderNav() {
  const {t} = useI18n();
  const {pathname} = useLocation();
  const [browseOpen, setBrowseOpen] = useState(false);
  useEffect(() => {
    function onBrowse() { setBrowseOpen(true); }
    window.addEventListener("cc-open-category-browse", onBrowse);
    return () => window.removeEventListener("cc-open-category-browse", onBrowse);
  }, []);
  function isActive(url: string) {
    if(url === "/") return pathname === "/";
    return pathname === url || pathname.startsWith(url + "/");
  }
  return (
    <>
      <nav className="cc-header__nav" aria-label={t("Main navigation")}>
        <div className="cc-header__container">
          <ul className="cc-header__navList">
            <li className="cc-header__navItem cc-header__navItem--browse">
              <button type="button" className="cc-header__navBrowse" onClick={() => setBrowseOpen(true)}>
                <i className="fa fa-th-large" aria-hidden="true" />
                <span>{t("Departments")}</span>
                <i className="fa fa-chevron-down cc-header__navBrowseCaret" aria-hidden="true" />
              </button>
            </li>
            <li className="cc-header__navDivider" aria-hidden="true" />
            {LINKS.map((link) => (
              <li key={link.id} className="cc-header__navItem">
                <Link to={link.to} className={`cc-header__navLink${link.promo ? " isPromo" : ""}${isActive(link.to) ? " isActive" : ""}`}>{t(link.labelKey)}</Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      <CategoryBrowseOverlay open={browseOpen} onClose={() => setBrowseOpen(false)} />
    </>
  );
}

export {openCategoryBrowse};
